import _defaultTo from "lodash/defaultTo";
import _get from "lodash/get";

export const formValue = (formData: Object, path: string, defaultValue: string = "") => {
  return _defaultTo(_get(formData, path), defaultValue);
};
